import { packagePickerTranslationsExtension } from '@wix/package-picker-shared';
export const EclipseTranslationsExtension = packagePickerTranslationsExtension;
//# sourceMappingURL=eclipse-translations.extension.js.map